import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-0b6f0926"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "wrapper-container"
};
var _hoisted_2 = {
  class: "inner-container"
};
var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("h2", {
    class: "title"
  }, "合作伙伴", -1);
});
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("h3", {
    class: "sub-title"
  }, "合作单位", -1);
});
var _hoisted_5 = ["src"];
var _hoisted_6 = ["src"];
var _hoisted_7 = ["src"];
var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("h3", {
    class: "sub-title"
  }, "合作学校", -1);
});
var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("ul", {
    class: "school-list"
  }, [/*#__PURE__*/_createElementVNode("li", null, "西安交通大学附属小学"), /*#__PURE__*/_createElementVNode("li", null, "西安高新国际学校"), /*#__PURE__*/_createElementVNode("li", null, "自贡市沿滩区第二小学"), /*#__PURE__*/_createElementVNode("li", null, "赣州市南康区第一小学"), /*#__PURE__*/_createElementVNode("li", null, "南昌师范附属实验小学")], -1);
});
var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("ul", {
    class: "school-list"
  }, [/*#__PURE__*/_createElementVNode("li", null, "宜春市文笔峰小学"), /*#__PURE__*/_createElementVNode("li", null, "惠州仲恺高新区第一小学"), /*#__PURE__*/_createElementVNode("li", null, "惠州市东湖双语学校"), /*#__PURE__*/_createElementVNode("li", null, "惠州市南坛小学鼎峰分校"), /*#__PURE__*/_createElementVNode("li", null, "楚雄开发区实验小学")], -1);
});
var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("ul", {
    class: "school-list"
  }, [/*#__PURE__*/_createElementVNode("li", null, "楚雄市思源实验学校"), /*#__PURE__*/_createElementVNode("li", null, "楚雄市环城小学"), /*#__PURE__*/_createElementVNode("li", null, "永康实验小学"), /*#__PURE__*/_createElementVNode("li", null, "龙游西门小学")], -1);
});
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_a_col = _resolveComponent("a-col");
  var _component_a_row = _resolveComponent("a-row");
  var _component_a_divider = _resolveComponent("a-divider");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_a_row, null, {
    default: _withCtx(function () {
      return [_createVNode(_component_a_col, {
        span: 24
      }, {
        default: _withCtx(function () {
          return [_hoisted_3];
        }),
        _: 1
      })];
    }),
    _: 1
  }), _createVNode(_component_a_row, null, {
    default: _withCtx(function () {
      return [_createVNode(_component_a_col, {
        span: 24
      }, {
        default: _withCtx(function () {
          return [_hoisted_4, _createVNode(_component_a_row, {
            justify: "center",
            gutter: [20, 24],
            class: "text-center"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_a_col, {
                span: 8
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("img", {
                    width: 280,
                    height: 96,
                    src: _ctx.partner1Image,
                    alt: "partner"
                  }, null, 8, _hoisted_5)];
                }),
                _: 1
              }), _createVNode(_component_a_col, {
                span: 8
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("img", {
                    width: 280,
                    height: 96,
                    src: _ctx.partner2Image,
                    alt: "partner"
                  }, null, 8, _hoisted_6)];
                }),
                _: 1
              }), _createVNode(_component_a_col, {
                span: 8
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("img", {
                    width: 280,
                    height: 96,
                    src: _ctx.partner3Image,
                    alt: "partner"
                  }, null, 8, _hoisted_7)];
                }),
                _: 1
              })];
            }),
            _: 1
          })];
        }),
        _: 1
      })];
    }),
    _: 1
  }), _createVNode(_component_a_row, {
    style: {
      "margin-top": "72px"
    }
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_a_col, {
        span: 24
      }, {
        default: _withCtx(function () {
          return [_hoisted_8, _createVNode(_component_a_row, {
            type: "flex",
            justify: "center"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_a_col, {
                span: 6,
                class: "align-center"
              }, {
                default: _withCtx(function () {
                  return [_hoisted_9];
                }),
                _: 1
              }), _createVNode(_component_a_col, {
                span: 1,
                class: "align-center"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_a_divider, {
                    type: "vertical",
                    class: "school-divider"
                  })];
                }),
                _: 1
              }), _createVNode(_component_a_col, {
                span: 6,
                class: "align-center"
              }, {
                default: _withCtx(function () {
                  return [_hoisted_10];
                }),
                _: 1
              }), _createVNode(_component_a_col, {
                span: 1,
                class: "align-center"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_a_divider, {
                    type: "vertical",
                    class: "school-divider"
                  })];
                }),
                _: 1
              }), _createVNode(_component_a_col, {
                span: 6,
                class: "align-center"
              }, {
                default: _withCtx(function () {
                  return [_hoisted_11];
                }),
                _: 1
              })];
            }),
            _: 1
          })];
        }),
        _: 1
      })];
    }),
    _: 1
  })])]);
}